"use client";

import type React from "react";
import { clsx } from "clsx";
import * as m from "motion/react-m";
import type { OrbMessage, AgentMessageStyle } from "./types";

const STAGGER_DELAY = 0.6;
const INITIAL_DELAY = 0.3;

const POINTY_RADIUS = "10px 10px 10px 4px";

export function InitialMessages({
  messages,
  agentMessageStyle = "default",
  gap = "default",
  pointyCorners = false,
}: {
  messages: OrbMessage[];
  agentMessageStyle?: AgentMessageStyle;
  gap?: "default" | "compact";
  pointyCorners?: boolean;
}) {
  const isBubble = agentMessageStyle === "dark" || agentMessageStyle === "warm";

  return (
    <div className={clsx("tw-flex tw-flex-col", gap === "default" && "tw-gap-4")}>
      {messages.map((message, index) => {
        const style: React.CSSProperties = {};
        if (agentMessageStyle === "warm") style.backgroundColor = "#F5F3F1";
        if (pointyCorners && isBubble) style.borderRadius = POINTY_RADIUS;
        if (gap === "compact" && index > 0) {
          style.marginTop = messages[index - 1].role === message.role ? "0.25rem" : "0.75rem";
        }

        return (
          <m.p
            key={message.id}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.5,
              delay: INITIAL_DELAY + index * STAGGER_DELAY,
              ease: [0.25, 0.1, 0.25, 1],
            }}
            className={clsx(
              "tw-text-sm/5 tw-text-black",
              isBubble && "tw-w-fit tw-py-2.5 tw-px-4 tw-max-w-[calc(100%-4rem)]",
              isBubble && !pointyCorners && "tw-rounded-2.5xl",
              agentMessageStyle === "dark" && "tw-bg-gray-200",
            )}
            style={Object.keys(style).length > 0 ? style : undefined}
          >
            {message.message}
          </m.p>
        );
      })}
    </div>
  );
}
